import classNames from 'classnames';
import dayjs from 'dayjs';
import { FC } from 'react';
import QRCode from 'react-qr-code';

import countryCodeToReadable from 'utils/country-code-to-readable';

import cardBack from './Back.png';
import cardFront from './Front.png';
import cardHiddenBack from './Hidden-Back.png';
import cardHiddenFront from './Hidden-Front.png';
import directorSignature from './director-signature.png';
import theme from './theme.module.scss';

type IdentityCard = {
  id: string;
  cardNumber: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    gender: string;
    department: {
      id: string;
      name: string;
    };
    nationality: string;
  };
  employee: {
    id: string;
    fileNumber: string;
    division: {
      id: string;
      name: string;
    };
    designation: {
      id: string;
      name: string;
    };
    signature?: string;
    photo: string;
  };
  codeLink: string;
  issueDate: string;
  expiryDate: string;
};

const NHCIdentityCard: FC<{
  identityCard: IdentityCard;
  visibileOnly?: boolean;
}> = ({ identityCard, visibileOnly = false }) => {
  const { label: countryLabel } = countryCodeToReadable(identityCard.user.nationality);

  const cardImage = {
    front: cardFront,
    hiddenFront: cardHiddenFront,
    back: cardBack,
    hiddenBack: cardHiddenBack,
  };

  return (
    <div className={theme.container}>
      <div className={theme.page}>
        <img className={theme.background} src={cardImage.front} alt="Card Front" />
        <span className={theme.heading}>NATIONAL HOUSING CORPORATION</span>
        <span className={theme.subHeading}>PAPUA NEW GUINEA</span>
        <img className={theme.photo} src={identityCard.employee.photo} alt="Employee" />
        <div className={theme.information}>
          <div className={theme.row}>
            <p className={theme.label}>First Name:</p>
            <p className={theme.value}>{identityCard.user.firstName}</p>
          </div>
          <div className={theme.row}>
            <p className={theme.label}>Last Name:</p>
            <p className={theme.value}>{identityCard.user.lastName}</p>
          </div>
          <div className={theme.columns}>
            <div className={theme.row}>
              <p className={theme.label}>File No:</p>
              <p className={theme.value}>{identityCard.employee.fileNumber}</p>
            </div>
            <div className={theme.row}>
              <p className={theme.label}>Gender:</p>
              <p className={theme.value}>{identityCard.user.gender}</p>
            </div>
          </div>
          <div className={theme.row}>
            <p className={theme.label}>Designation:</p>
            <p className={theme.value}>{identityCard.employee.designation.name}</p>
          </div>
        </div>
        <div className={theme.signaturesContainer}>
          <div className={theme.signature}>
            {/* <img
              src={identityCard.employee.signature}
              alt="Employee Signature"
              className={theme.signatureImage}
            /> */}
            <span className={theme.automatedSignature}>
              {identityCard.user.firstName.toLowerCase()} {identityCard.user.lastName.toLowerCase()}
            </span>
            <p className={theme.label}>Signature of Holder</p>
          </div>
          {identityCard.employee.designation.name === 'Managing Director' ? null : (
            <div className={theme.signature}>
              <img
                src={directorSignature}
                alt="Director Signature"
                className={theme.signatureImage}
              />
              <p className={theme.label}>Signature of Managing Director</p>
            </div>
          )}
        </div>
      </div>
      <div className={theme.page} style={{ display: visibileOnly ? 'none' : 'block' }}>
        <img className={theme.background} src={cardImage.hiddenFront} alt="Card Hidden Front" />
      </div>
      <div className={classNames(theme.page, theme.back)}>
        <img className={theme.background} src={cardImage.back} alt="Card Back" />
        <img className={theme.photo} src={identityCard.employee.photo} alt="Employee" />
        <span className={theme.note}>
          This card is the property of National Housing Corporation
        </span>
        <div className={theme.qrCodeContainer}>
          <QRCode value={identityCard.codeLink} size={525} />
        </div>
        <div className={theme.information}>
          <div className={theme.row}>
            <p className={theme.label}>Nationality:</p>
            <p className={theme.value}>{countryLabel}</p>
          </div>
          <div className={theme.row}>
            <p className={theme.label}>Card No:</p>
            <p className={theme.value}>{identityCard.cardNumber}</p>
          </div>
          <div className={theme.columns}>
            <div className={theme.row}>
              <p className={theme.label}>Issue Date:</p>
              <p className={theme.value}>{dayjs(identityCard.issueDate).format('DD MMMM YYYY')}</p>
            </div>
            <div className={theme.row}>
              <p className={theme.label}>Expiry Date:</p>
              <p className={theme.value}>{dayjs(identityCard.expiryDate).format('DD MMMM YYYY')}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        className={classNames(theme.page, theme.hidden)}
        style={{ display: visibileOnly ? 'none' : 'block' }}
      >
        <img className={theme.background} src={cardImage.hiddenBack} alt="Card Hidden Back" />
        <img className={theme.photo} src={identityCard.employee.photo} alt="Employee" />
      </div>
    </div>
  );
};

export default NHCIdentityCard;
